<template>
  <div>
    <div
      class="gdlr-core-pbf-wrapper"
      id="div_1dd7_30"
      data-skin="Column Service"
    >
      <div class="gdlr-core-pbf-background-wrap" id="div_1dd7_31"></div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div
          class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container"
        >
          <div
            class="gdlr-core-pbf-column gdlr-core-column-15"
            v-for="(jurusan, index) in majors.slice(0, 4)"
            :key="`jurusan_${index}`"
            data-aos="zoom-in"
            :data-aos-duration="index + `000`"
            :data-aos-delay="index + `00`"
          >
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js">
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-column-service-item gdlr-core-item-pdb gdlr-core-left-align gdlr-core-column-service-icon-top gdlr-core-no-caption gdlr-core-item-pdlr"
                    id="div_1dd7_32"
                  >
                    <!-- <div
                      class="gdlr-core-column-service-media gdlr-core-media-image"
                      id="div_1dd7_33"
                    >
                      <img
                        :src="
                          require('@/assets/images/template4/col-icon-1.png')
                        "
                        alt=""
                        width="41"
                        height="41"
                        title="col-icon-1"
                      />
                    </div> -->
                    <div class="gdlr-core-column-service-content-wrapper">
                      <div class="gdlr-core-column-service-title-wrap">
                        <h3
                          class="gdlr-core-column-service-title gdlr-core-skin-title"
                          id="h3_1dd7_6"
                        >
                          {{ jurusan.title }}
                        </h3>
                      </div>
                      <div
                        class="gdlr-core-column-service-content"
                        id="div_1dd7_34"
                        v-html="jurusan.body.slice(0, 150) + `...`"
                      ></div>
                      <router-link
                        class="gdlr-core-column-service-read-more gdlr-core-info-font"
                        :to="`/jurusan-detail/${jurusan.url}`"
                        id="a_1dd7_1"
                        >Selengkapnya</router-link
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div
            class="gdlr-core-pbf-column gdlr-core-column-15"
            id="gdlr-core-column-5"
          >
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js">
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-column-service-item gdlr-core-item-pdb gdlr-core-left-align gdlr-core-column-service-icon-top gdlr-core-no-caption gdlr-core-item-pdlr"
                    id="div_1dd7_35"
                  >
                    <div
                      class="gdlr-core-column-service-media gdlr-core-media-image"
                      id="div_1dd7_36"
                    >
                      <img
                        :src="
                          require('@/assets/images/template4/col-icon-2.png')
                        "
                        alt=""
                        width="43"
                        height="45"
                        title="col-icon-2"
                      />
                    </div>
                    <div class="gdlr-core-column-service-content-wrapper">
                      <div class="gdlr-core-column-service-title-wrap">
                        <h3
                          class="gdlr-core-column-service-title gdlr-core-skin-title"
                          id="h3_1dd7_7"
                        >
                          International Hubs
                        </h3>
                      </div>
                      <div
                        class="gdlr-core-column-service-content"
                        id="div_1dd7_37"
                      >
                        <p>
                          Kingster University was established by John Smith in
                          1920 for the public benefit and it is recognized.
                        </p>
                        <a
                          class="gdlr-core-column-service-read-more gdlr-core-info-font"
                          href="#"
                          id="a_1dd7_2"
                          >Learn More</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "majors",
  props: ["majors"],
};
</script>
